import {initializeApp} from "firebase/app";
import {getAuth} from "firebase/auth";
import { getStorage } from "firebase/storage";

import {
    getFirestore,
} from "firebase/firestore";

import {TEST_ENVIRONMENT} from "../constants";

// Firebase configuration
const firebaseConfig = TEST_ENVIRONMENT
    ? {
        apiKey: 'AIzaSyCZRZGhNWlxbl0x1YlhLqlRw0dtTrYgqqQ',
        authDomain: 'fryda-testing.firebaseapp.com',
        projectId: 'fryda-testing',
        storageBucket: 'fryda-testing.appspot.com',
        messagingSenderId: '932104963422',
        appId: '1:932104963422:web:630eaf1cc74aa3f49f3bcf',
    }
    : {
        apiKey: 'AIzaSyAIE3eJ7IgOrYNl60bmfAM1SOpRABt88xM',
        authDomain: 'products-a14cf.firebaseapp.com',
        projectId: 'products-a14cf',
        storageBucket: 'products-a14cf.appspot.com',
        messagingSenderId: '234454775205',
        appId: '1:234454775205:web:3646ad294a73a2e0b4e44c',
        measurementId: 'G-X8J2DM9LP2',
    }

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const auth = getAuth(app);

//storage
const storage = getStorage(app);

export {db, auth, storage};